import React from 'react';
import PropTypes from "prop-types";

const ModalSaveButton = ({buttonDisabled, onClick, children}) =>
{
    const clickHandler = buttonDisabled === false ? onClick : null;

    return (
        <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonDisabled}
                className='btn btn-icon btn-primary btn-icon-right btn-small'>{children}<i className="et-save"/>
        </button>
    )
}

export default ModalSaveButton;

ModalSaveButton.defaultProps =
{
    buttonDisabled: false,
    onClick: null
}

ModalSaveButton.propTypes = {
    onClick: PropTypes.func,
    buttonDisabled: PropTypes.bool
};
